export default "__VITE_ASSET__d06b3111__"